import valid from "card-validator"
import { put, select } from "redux-saga/effects"
import isEmail from "validator/lib/isEmail"

import { firstName, joinNames, lastName } from "helpers/name"

import { debounceOrderValues, setCheckoutReady } from "../actions"

export default function* handleFormikChange(action) {
  const current = action.current
  const prev = action.prev
  const setFieldValue = action.setFieldValue
  const state = yield select()
  let returnFlag = false
  // let shouldUpdateAddresses = false

  if (current.values.cc && current.values.cc.expiry != prev.values.cc.expiry) {
    // Parse the expiry using card validator
    const expDate = valid.expirationDate(current.values.cc.expiry)
    if (expDate.isValid) {
      setFieldValue("cc.cc_expiry_month", expDate.month)
      if (expDate.year.length == 2) {
        setFieldValue("cc.cc_expiry_year", "20" + expDate.year)
      } else {
        setFieldValue("cc.cc_expiry_year", expDate.year)
      }
    } else {
      setFieldValue("cc.cc_expiry_month", "")
      setFieldValue("cc.cc_expiry_year", "")
    }
  }

  if (
    typeof current.values.ship_full_name !== "undefined" &&
    current.values.ship_full_name != prev.values.ship_full_name
  ) {
    // shouldUpdateAddresses = true

    setFieldValue(
      "order.ship_address_attributes.first_name",
      firstName(current.values.ship_full_name)
    )
    setFieldValue(
      "order.ship_address_attributes.last_name",
      lastName(current.values.ship_full_name)
    )

    // We need to specially set the billing name to the shipping name if changed here
    if (current.values.same_as_shipping_address_b) {
      setFieldValue("bill_full_name", current.values.ship_full_name)

      setFieldValue(
        "order.bill_address_attributes.first_name",
        firstName(current.values.ship_full_name)
      )

      setFieldValue(
        "order.bill_address_attributes.last_name",
        lastName(current.values.ship_full_name)
      )
    }
    setFieldValue(
      "order.same_as_shipping_address_b",
      current.values.same_as_shipping_address_b
    )

    returnFlag = true
  }

  if (
    typeof current.values.bill_full_name !== "undefined" &&
    current.values.bill_full_name != prev.values.bill_full_name
  ) {
    // shouldUpdateAddresses = true

    setFieldValue(
      "order.bill_address_attributes.first_name",
      firstName(current.values.bill_full_name)
    )
    setFieldValue(
      "order.bill_address_attributes.last_name",
      lastName(current.values.bill_full_name)
    )
    setFieldValue("customer_full_name", current.values.bill_full_name)
    setFieldValue(
      "order.customer_first_name",
      firstName(current.values.bill_full_name)
    )
    setFieldValue(
      "order.customer_last_name",
      lastName(current.values.bill_full_name)
    )
    returnFlag = true
  }

  // Unchecking the billing address same as shipping address box causes blanks on all billing fields
  if (
    current.values.same_as_shipping_address_b !=
    prev.values.same_as_shipping_address_b
  ) {
    setFieldValue(
      "order.same_as_shipping_address_b",
      current.values.same_as_shipping_address_b
    )
    if (current.values.same_as_shipping_address_b) {
      const shipAddress =
        current.values.order && current.values.order.ship_address_attributes
          ? current.values.order.ship_address_attributes
          : {}
      if (
        !state.checkout.order.order.has_gift_properties &&
        (typeof prev.values.bill_full_name === "undefined" ||
          current.values.bill_full_name === prev.values.ship_full_name)
      ) {
        setFieldValue(
          "bill_full_name",
          joinNames(shipAddress.first_name, shipAddress.last_name)
        )

        setFieldValue(
          "order.bill_address_attributes.first_name",
          shipAddress.first_name || ""
        )
        setFieldValue(
          "order.bill_address_attributes.last_name",
          shipAddress.last_name || ""
        )
      }
      setFieldValue(
        "order.bill_address_attributes.address1",
        shipAddress.address1 || ""
      )
      setFieldValue(
        "order.bill_address_attributes.address2",
        shipAddress.address2 || ""
      )
      setFieldValue(
        "order.bill_address_attributes.city",
        shipAddress.city || ""
      )
      setFieldValue(
        "order.bill_address_attributes.state",
        shipAddress.state || ""
      )
      if (shipAddress.country && shipAddress.country != "") {
        setFieldValue(
          "order.bill_address_attributes.country",
          shipAddress.country || ""
        )
      }
      setFieldValue(
        "order.bill_address_attributes.postal_code",
        shipAddress.postal_code || ""
      )
    } else {
      setFieldValue("order.bill_address_attributes.address1", "")
      setFieldValue("order.bill_address_attributes.address2", "")
      setFieldValue("order.bill_address_attributes.city", "")
      setFieldValue("order.bill_address_attributes.state", "")
      setFieldValue("order.bill_address_attributes.postal_code", "")
    }
    // yield put(setCheckoutReady(false))
    // yield put(debounceOrderValues(current, setFieldValue, "address"))
    return
  }

  // Special logic to replicate entered values across several form fields
  // Basic flow:
  // - Check current value against previous value for a change
  // - Check prev value against the current value of a linked field
  // - If the prev value matches current value of linked field, update with the current value
  //   of the field that we've been checking
  //
  // This means if information is corrected in, say, the shipping address, changing the customer information
  // won't update the shipping address that was just corrected, since normal use case is to change the shipping
  // name but then fix a typo in the customer name (now not tied together)
  // We don't need ANY of this when the order is amazon
  if (current.values.order) {
    ;[
      [
        current.values.ship_full_name, // field to pull from
        prev.values.ship_full_name || "", // previous value of pulled field
        current.values.customer_full_name, // field to link to
        "customer_full_name", // formik format of linked field
        true, // whether to apply this link (handy for billing same as shipping checkbox)
      ],
      // [
      //   current.values.order.customer_first_name,
      //   prev.values.order ? prev.values.order.customer_first_name : "",
      //   current.values.order.ship_address_attributes.first_name,
      //   "order.ship_address_attributes.first_name",
      //   true
      // ],
      // [
      //   current.values.order.customer_last_name,
      //   prev.values.order ? prev.values.order.customer_first_name : "",
      //   current.values.order.ship_address_attributes.first_name,
      //   "order.ship_address_attributes.first_name",
      //   true
      // ],
      [
        current.values.order.customer_phone,
        prev.values.order ? prev.values.order.customer_phone : "",
        current.values.order.ship_address_attributes.phone,
        "order.ship_address_attributes.phone",
        true,
      ],
      // [
      //   current.values.ship_full_name,
      //   prev.values.ship_full_name || "",
      //   current.values.bill_full_name,
      //   "order.bill_full_name",
      //   current.values.same_as_shipping_address_b
      // ],
      [
        current.values.order.ship_address_attributes.address1,
        prev.values.order
          ? prev.values.order.ship_address_attributes.address1
          : "",
        current.values.order.bill_address_attributes.address1,
        "order.bill_address_attributes.address1",
        current.values.same_as_shipping_address_b,
      ],
      [
        current.values.order.ship_address_attributes.address2,
        prev.values.order
          ? prev.values.order.ship_address_attributes.address2
          : "",
        current.values.order.bill_address_attributes.address2,
        "order.bill_address_attributes.address2",
        current.values.same_as_shipping_address_b,
      ],
      [
        current.values.order.ship_address_attributes.city,
        prev.values.order ? prev.values.order.ship_address_attributes.city : "",
        current.values.order.bill_address_attributes.city,
        "order.bill_address_attributes.city",
        current.values.same_as_shipping_address_b,
      ],
      [
        current.values.order.ship_address_attributes.state,
        prev.values.order
          ? prev.values.order.ship_address_attributes.state
          : "",
        current.values.order.bill_address_attributes.state,
        "order.bill_address_attributes.state",
        current.values.same_as_shipping_address_b,
      ],
      [
        current.values.order.ship_address_attributes.postal_code,
        prev.values.order
          ? prev.values.order.ship_address_attributes.postal_code
          : "",
        current.values.order.bill_address_attributes.postal_code,
        "order.bill_address_attributes.postal_code",
        current.values.same_as_shipping_address_b,
      ],
    ].forEach((cv) => {
      // if !current.values.same_as_shipping_address_b
      if (!cv[4]) {
        return
      }
      if (
        cv[0] &&
        // current.values.order.customer_first_name != prev.values.order.customer_first_name
        cv[0] != cv[1] &&
        // current.values.order.ship_address_attributes.first_name == prev.values.order.customer_first_name
        (cv[2] == cv[1] ||
          // current.values.order.ship_address_attributes.first_name == ''
          cv[2] == "")
      ) {
        // setFieldValue('order.ship_address_attributes.first_name', current.values.order.customer_first_name || '')
        setFieldValue(cv[3], cv[0])
        returnFlag = true
      }
    })
  }

  if (
    current.values.order.bill_address_attributes.country !=
    prev.values.order.bill_address_attributes.country
  ) {
    setFieldValue("order.bill_address_attributes.state", "")
  }

  if (returnFlag) {
    // We reduce extra overhead by returning this iteration, since it will be caught in a future handleFormik
    // return
  }
  // End special logic - now dispatch to the store so it can be tracked as the form is completed

  /* Determine which api endpoint to use for updating order */

  // Updating order email/account creation
  if (
    current.values.order.opt_in != prev.values.order.opt_in ||
    (current.values.order.email != prev.values.order.email &&
      isEmail(current.values.order.email || "")) ||
    (current.values.order.create_account != prev.values.order.create_account &&
      !current.values.order.create_account) ||
    current.values.order.account_create_password !=
      prev.values.order.account_create_password
  ) {
    setFieldValue("account_create_error", "")
    yield put(setCheckoutReady(false))
    yield put(debounceOrderValues(current, setFieldValue, "email"))
    return
  }

  // Updating addresses
  // if (
  //   JSON.stringify(current.values.order.bill_address_attributes) !==
  //     JSON.stringify(prev.values.order.bill_address_attributes) ||
  //   JSON.stringify(current.values.order.ship_address_attributes) !==
  //     JSON.stringify(prev.values.order.ship_address_attributes) ||
  //   shouldUpdateAddresses
  // ) {
  //   yield put(setCheckoutReady(false))
  //   yield put(debounceOrderValues(current, setFieldValue, "address"))
  //   return
  // }

  // Updating shipping method
  if (current.values.ship_method_id != prev.values.ship_method_id) {
    yield put(setCheckoutReady(false))
    yield put(debounceOrderValues(current, setFieldValue, "shipping_method"))
    return
  }

  // debounceOrderValues is a wrapper for updateOrderValues that takes advantage of redux saga
  // in order to make sure that we don't hammer the redux reducer logic with unnecessary updates
  yield put(debounceOrderValues(current, setFieldValue, "none"))
}
